module.exports = __webpack_public_path__ + "img/10.a1ba564a.jpg";